import {createSelector} from "@reduxjs/toolkit";
import {OtsUIState} from "../../ots-ui-store";

const selectId = (_state: OtsUIState, id: string) => id
const selectPipelineUI = (state: OtsUIState) => state.uiPipeline

export const selectPipelineUIFilter = createSelector([selectPipelineUI, selectId], (ui, id) => ui[id]?.filter)
